// PurchaseComponent.js
import React, { useState } from 'react';
import CheckOutModal from '../CheckOutModal';

function PurchaseComponent() {
  const [purchaseModal, setPurchaseModal] = useState(false);

  return (
    <div
      className="card shadow-sm"
      style={{
        padding: '24px',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        backgroundColor: '#fff',
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0">Buy Credits</h6>
        <button
          onClick={() => setPurchaseModal(true)}
          className="btn btn-primary"
          style={{ height: '45px' }}
        >
          Purchase
        </button>
      </div>

      {/* Modal */}
      <CheckOutModal show={purchaseModal} onClose={() => setPurchaseModal(false)} />
    </div>
  );
}

export default PurchaseComponent;
